<ng-container *transloco="let t">
<ng-template #pullExistingApplication>

  <div class="row editor-container">
    <div class="col-12 container">
      <form #loanInfoForm="ngForm" class="form" novalidate id="loanInfoForm" name="loanInfoForm">
        <div style="margin: 0 auto;">
          <div class="fv-row mb-3">
            <div>
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
                <span>{{ t('wizard.pullExistingApp.enterPropertyZip') }}</span>
              </label>
              <div class="position-relative">
                <input #enteredZipCode="ngModel" type="text" [dropSpecialCharacters]="false"
                  [validation]="false" [pattern]="zipCodePattern" [mask]="zipCodeMask" [placeholder]="zipCodePlaceHolder"
                  [name]="'zipCode'" [id]="'zipCode'" [required]="true" [(ngModel)]="subjectPropertyZipCode"
                  (keydown.enter)="onSubmitClicked()" class="form-control form-control-solid" [ngClass]="{
                  'is-invalid':
                    enteredZipCode && enteredZipCode.touched && enteredZipCode.invalid
                }" />
                <div class="invalid-feedback">{{ t('wizard.pullExistingApp.pleaseEnterZip') }}</div>
              </div>
            </div>
          </div>
          <div class="fv-row mb-3">
            <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
              <span>{{ t('wizard.pullExistingApp.enterLastFourSSN') }}</span>
            </label>
            <div class="position-relative">
              <input class="form-control form-control-solid" [showMaskTyped]="true" [(ngModel)]="borrowerSSNLastFourDigits"
                #socialSecNum="ngModel" [dropSpecialCharacters]="false" [mask]="ssnMask" [pattern]="ssnPattern"
                [placeholder]="t('wizard.pullExistingApp.lastFourSSNPlaceholder')" name="ssn" id="ssn" (keydown.enter)="onSubmitClicked()"
                [required]="true" [ngClass]="{
                'is-invalid':
                  socialSecNum && socialSecNum.touched && socialSecNum.invalid
              }" />
              <div class="invalid-feedback">
                {{ t('wizard.pullExistingApp.pleaseEnterLastFourSSN') }}
              </div>
            </div>
          </div>
          @if (pullInfoAttemptCount > 0) {
            <div class="fv-row button-container">
              <a (click)="onSubmitClicked()" class="btn btn-success">{{ t('wizard.pullExistingApp.getMyInfo') }}</a>
            </div>
          }
          @if (pullAttemptFailed && pullInfoAttemptCount > 0) {
            <div class="fv-row mt-1">
              {{ t('wizard.pullExistingApp.unableToVerifyRetry', { count: pullInfoAttemptCount }) }}
            </div>
          }
          @if (pullAttemptFailed && pullInfoAttemptCount === 0) {
            <div class="fv-row mt-1">
              {{ t('wizard.pullExistingApp.unableToVerifySkip') }}
            </div>
          }
        </div>
      </form>
    </div>
  </div>

</ng-template>

<wizard-step-template [stepMainTemplate]="pullExistingApplication" [step]="step"
  [stepComponent]="this"></wizard-step-template>
</ng-container>
